import { PRODUCTS } from './registry'
import { ProductTile } from './ProductTile'

/** Compact horizontal row of product tiles for the Home view. */
export function ProductsRow() {
  return (
    <div className="scroll-x products__row">
      {PRODUCTS.map((p) => (
        <ProductTile key={p.id} product={p} compact />
      ))}
    </div>
  )
}
